import './RemovalFlag.css';

function CircleSlashIcon() {
  return (
    <svg className="removal-icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.25" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M6.4 6.4 L17.6 17.6" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export default function RemovalFlag({
  isAdmin,
  flagCount = 0,
  flaggedBy = [],
  flaggedByMe,
  onToggle,
}: {
  isAdmin: boolean;
  flagCount?: number;
  flaggedBy?: string[];
  flaggedByMe: boolean;
  onToggle?: () => void;
}) {
  const names = flaggedBy.length ? flaggedBy.join(', ') : 'a viewer';
  const adminTitle = `Needs removal. Flagged by ${names}.`;

  if (isAdmin) {
    if (flagCount < 1) return null;
    return (
      <span className="removal-flag is-alert" title={adminTitle} role="img" aria-label={adminTitle}>
        <CircleSlashIcon />
      </span>
    );
  }

  if (!onToggle) return null;

  return (
    <button
      type="button"
      className={`removal-flag${flaggedByMe ? ' is-on' : ''}`}
      aria-pressed={flaggedByMe}
      title={flaggedByMe ? 'Cancel removal request' : 'Ask the host to remove this video'}
      onClick={onToggle}
    >
      <CircleSlashIcon />
      <span className="sr-only">
        {flaggedByMe ? 'Cancel removal request' : 'Ask the host to remove this video'}
      </span>
    </button>
  );
}
